module.exports = "<div [formGroup]=\"form\">\n  <div form-host></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/form/core/component/form-parent/form-parent.component.html
// module id = 1109
// module chunks = 0